import { graphql, useStaticQuery } from 'gatsby';

export const useSpeciesImages = () => {
  const images = useStaticQuery(graphql`
    query SpeciesSelectionImagesHook {
      rabbit: file(relativePath: { eq: "species/rabbit.jpg" }) {
        ...SpeciesImage
      }
      dog: file(relativePath: { eq: "species/dog.jpg" }) {
        ...SpeciesImage
      }
      servicedog: file(relativePath: { eq: "species/servicedog.jpg" }) {
        ...SpeciesImage
      }
      cat: file(relativePath: { eq: "species/cat.jpg" }) {
        ...SpeciesImage
      }
      puppy: file(relativePath: { eq: "species/puppy.jpg" }) {
        ...SpeciesImage
      }
      kitten: file(relativePath: { eq: "species/kitten.jpg" }) {
        ...SpeciesImage
      }
      equine: file(relativePath: { eq: "species/horse.jpg" }) {
        ...SpeciesImage
      }
    }

    fragment SpeciesImage on File {
      childImageSharp {
        gatsbyImageData(
          width: 256
          height: 256
          layout: CONSTRAINED
          placeholder: BLURRED
          formats: AUTO
          transformOptions: { fit: COVER }
          quality: 90
        )
      }
    }
  `);

  return images;
};
